import React from 'react';
import { Route } from 'react-router-dom';

import HomeAlerta from '../../Home/Alertas/HomeAlertas';
import DemandasInformacoesFicha from '../../Home/DemandasInformacoes/DemandasInformacoesFicha';
import DemandasInformacoesIndex from '../../Home/DemandasInformacoes/DemandasInformacoesIndex';
import GlossarioFicha from '../../Home/Glossario/GlossarioFicha';
import GlossarioIndex from '../../Home/Glossario/GlossarioIndex';
import HomeInicio from '../../Home/Inicio/HomeInicio';
import HomeNumero from '../../Home/Números/HomeNumeros';

const HomeRoutes = () => {
  return (
    <>
      <Route path="home/inicio" element={<HomeInicio />} />
      <Route path="home/alertas" element={<HomeAlerta />} />
      <Route path="home/numeros" element={<HomeNumero />} />

      {/* Glossário */}
      <Route path="home/glossario" element={<GlossarioIndex />} />
      <Route
        path="home/glossario/ficha/dadosgerais"
        element={<GlossarioFicha />}
      />
      <Route
        path="home/glossario/ficha/:id/dadosgerais"
        element={<GlossarioFicha />}
      />

      {/* Demandas de Informações */}
      <Route
        path="home/demandasinformacoes"
        element={<DemandasInformacoesIndex />}
      />
      <Route
        path="home/demandasinformacoes/ficha/dadosgerais"
        element={<DemandasInformacoesFicha />}
      />
      <Route
        path="home/demandasinformacoes/ficha/:id/dadosgerais"
        element={<DemandasInformacoesFicha />}
      />
    </>
  );
};

export default HomeRoutes;
